module.exports = __webpack_public_path__ + "img/min-main-logo.3c7953c8.png";